// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1ZkFr","content":"LayoutSettings_content__Xmon5"};